// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"271":"605934d2","870":"06d75d20"}[chunkId] + ".chunk.css";
};